<template>
  <ResponsiveModal
    :title="t('components.asset_groups.edit.title')"
    @update:open="reset"
    @confirm="handleUpdateAssetGroup"
    :withClose="false"
  >
    <template #content>
      <div class="p-4">
        <TextInput :modelValue="name" @update:modelValue="handleUpdateName" />
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { nextTick, ref } from "vue";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { TextInput } from "@/SharedComponents/Inputs";

import { useI18n } from "vue-i18n";

// Translations
const { t } = useI18n();

// Define Emits
const emit = defineEmits(["update:group"]);

// Define Props
const props = defineProps({
  item: { type: Object, required: false },
});

const name = ref(props.item.name);

const reset = () => {
  nextTick(() => {
    name.value = props.item.name;
  });
};

const handleUpdateName = (value) => {
  name.value = value;
};

const handleUpdateAssetGroup = () => {
  emit("update:group", { name: name.value, id: props.item.id });
};
</script>
